import { Component, inject } from '@angular/core';
import { ModalViewProperties } from '../modal-view-properties';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonSizes, ButtonStyles, ZiroButtonComponent } from '../../button/button.component';
import { CustomModal } from '../../shared/services/ziro-modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../shared/pipes/pipes.module';

interface DeletedAgentErrorModalViewProperties {
  username: string;
}

@Component({
  selector: 'ziro-deleted-agent-error-modal',
  templateUrl: './deleted-agent-error-modal.component.html',
  styleUrls: ['./deleted-agent-error-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, ZiroButtonComponent, PipesModule],
})
export class DeletedAgentErrorModalComponent implements CustomModal<DeletedAgentErrorModalViewProperties> {
  private activeModal = inject(NgbActiveModal);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  modalProperties: DeletedAgentErrorModalViewProperties;
  username: string;
  modalViewProperties: ModalViewProperties;

  buttonStyles = ButtonStyles;
  buttonSizes = ButtonSizes;

  onReturnTo360ViewClicked(): void {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  onCancelClicked(): void {
    this.activeModal.close(false);
  }
}
